import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})

export class SeguroServices {

  constructor(private http: HttpClient){}

  public ListarSolicitacoes():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/Seguro/ListarSocilitacoes`)
  }

  public ListaContratados():Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/Seguro/ListaContratados`)
  }

  public BaixarArquivoProposta(codSolic: number): Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/Seguro/BaixarArquivoProposta?codSolic=${codSolic}`, {responseType: "blob"})
  }

  public BaixarArquivoCertificado(codPart: number, codSeguro: number): Observable<any> {
    return this.http
                .get(`${environment.apiURL}/Logado/Seguro/Seguro/BaixarArquivoCertificado?codPart=${codPart}&codSeguro=${codSeguro}`, {responseType: "blob"})
  }

}